import { on } from '@ember/modifier';
import { action } from '@ember/object';
import Component from '@glimmer/component';

import highlightResult from 'webapp/helpers/highlight-result';
import BoardImagePreviewComponent from 'webapp/components/board/image-preview';
import ScrollableTextComponent from 'webapp/components/scrollable-text';

import type { Report } from 'webapp/models-custom';
import BoardLoop from 'webapp/models-custom/board-loop';
import type { BoardSelectListSingleItem } from 'webapp/models-custom/filter-sort/board-select-list-single';

interface SelectListSingleItemArgs {
	item: unknown; // bcos of the list/auto-loaded inner typings
	onSelect: (item: BoardSelectListSingleItem) => void;
}

export default class BoardsPopupSelectListSingleItemComponent extends Component<{
	Args: SelectListSingleItemArgs;
}> {
	get model() {
		return this.args.item as BoardSelectListSingleItem;
	}

	get modelAsReport() {
		return this.model as Report;
	}

	get count() {
		const model = this.model;
		return model instanceof BoardLoop ? model.boardCount : 0;
	}

	@action
	select(): void {
		this.args.onSelect(this.model);
	}

	<template>
		<li role="button" {{on "click" this.select}}>
			<div class="item">
				<span class="item__image_wrapper">
					<BoardImagePreviewComponent
						@image={{this.model.image}}
						@color={{this.model.color}}
						@fallbackImage={{this.modelAsReport.fallbackImage}}
						@count={{this.count}}
						@theme={{this.model.bgTheme}}
					/>
				</span>
				<span class="item__name_wrapper">
					<span class="item__name">
						<span class="label">
							<ScrollableTextComponent>
								{{highlightResult
									text=this.model.name
									match=this.model.activeFilter
								}}
							</ScrollableTextComponent>
						</span>
					</span>
				</span>
			</div>
		</li>
	</template>
}
